import { connect, useDispatch, useSelector } from 'react-redux';
import {
  convertRealStatusToNotiStatus,
  actionDeleteJobSDO,
  actionRetryJob,
  NotificationInterface,
  actionShowOrHideNotificationList,
  selectSDOs,
} from '@common-modules/notification';
import {
  selectShowOrHideNotificationList,
  TYPE_COMPLETE,
  TYPE_FAILED,
  TYPE_PREPARING,
  TYPE_PROCESSING,
} from '@common-modules/notification/selectors';
import CloseIcon from '@mui/icons-material/Close';
import RefreshIcon from '@mui/icons-material/Refresh';
import ErrorIconSvg from '@resources/images/icon_error.svg';
import CheckIconSvg from '@resources/images/icon_check_circle.svg';
import { ArrowDropUp } from '@mui/icons-material';
import {
  Box,
  CircularProgress,
  Grid2 as Grid,
  IconButton,
  Paper,
  Link,
  ThemeProvider,
} from '@mui/material';
import { useStyles } from './styles';
import { showOrHideBadge } from '@redact-components/AppBar/notificationBadge';
import theme from '@redact/materialUITheme';
import { openMediaDetails } from '@redact-modules/mainPage/actions';
import Dialog from '@mui/material/Dialog';
import { I18nTranslate } from '@i18n';

const CustomNotificationContent = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const listNotification = useSelector(selectSDOs);
  const showNotificationList = useSelector(selectShowOrHideNotificationList);

  const showOrHideNotificationPopup = () => {
    dispatch(actionShowOrHideNotificationList());
  };

  const deleteNotification = (
    sdoId: string | undefined,
    noti: NotificationInterface
  ) => {
    if (sdoId) {
      if (notificationCount === 1) {
        showOrHideBadge(false);
        showOrHideNotificationPopup();
      }
      dispatch(actionDeleteJobSDO({ id: sdoId, data: noti }));
    }
  };

  const retryNotification = (sdoId: string | undefined) => {
    if (sdoId) {
      dispatch(actionRetryJob({ id: sdoId }));
    }
  };

  const getNotificationDetail = (noti: NotificationInterface) => {
    if (!(noti.deleted || noti.status === 'cancelled')) {
      const status = convertRealStatusToNotiStatus(noti.status);
      return (
        <Grid
          container
          key={noti.sdoId}
          justifyContent="center"
          alignItems="center"
          className={classes.notificationDetail}
          aria-label="custom-notification-detail"
        >
          <Grid size={{ xs: 1 }} title={status} component="div">
            {(status === TYPE_PROCESSING || status === TYPE_PREPARING) && (
              <Box className={classes.progressSpinner}>
                <CircularProgress color="inherit" thickness={3} size={25} />
              </Box>
            )}
            {status === TYPE_FAILED && <img alt={status} src={ErrorIconSvg} />}
            {status === TYPE_COMPLETE && (
              <img alt={status} src={CheckIconSvg} />
            )}
          </Grid>
          <Grid size={{ xs: 8 }} component="div">
            <span title="File Name" className={classes.notificationLink}>
              <Link
                href="#"
                underline="hover"
                onClick={() => {
                  dispatch(openMediaDetails({ tdoId: noti.tdoId }));
                }}
              >
                {noti.tdoName}
              </Link>
            </span>
            <span className={classes.notificationProcess} title="Engine Name">
              {noti.engineName}
            </span>
          </Grid>
          <Grid size={{ xs: 1 }} title="status" component="div">
            <Box justifyContent="flex-end">
              <span>{noti.status}</span>
            </Box>
          </Grid>
          <Grid size={{ xs: 2 }} justifyContent="flex-end" component="div">
            <div className={classes.actions}>
              {status === TYPE_FAILED && noti.jobId && (
                <IconButton
                  className={classes.actionButton}
                  title="Retry"
                  onClick={() => retryNotification(noti.jobId)}
                  size="large"
                >
                  {<RefreshIcon color="inherit" />}
                </IconButton>
              )}
              <IconButton
                className={classes.actionButton}
                onClick={() => {
                  if (noti.jobId) {
                    deleteNotification(noti.sdoId, noti);
                  }
                }}
                size="large"
              >
                {<CloseIcon color="inherit" />}
              </IconButton>
            </div>
          </Grid>
        </Grid>
      );
    }
  };

  const notificationCount =
    listNotification?.filter(
      (noti) => !(noti.deleted || noti.status === 'cancelled')
    )?.length || 0;

  return showNotificationList ? (
    <Dialog open onClose={showOrHideNotificationPopup}>
      <Grid
        container
        title="Notifications"
        className={classes.notificationModalContainer}
      >
        <Grid size={{ xs: 12 }} component="div">
          <Box className={classes.notificationHeader}>
            <span className={classes.notificationTitle}>
              {notificationCount ? (
                <>
                  <span className={classes.notificationTitleText}>
                    {I18nTranslate.TranslateMessage('itemsInQueue')}
                  </span>
                  <Paper className={classes.notificationCount}>
                    {notificationCount}
                  </Paper>
                </>
              ) : (
                <span className={classes.notificationTitleText}>
                  {I18nTranslate.TranslateMessage('noItemsInQueue')}
                </span>
              )}
            </span>
            <span className={classes.notificationClose}>
              <IconButton onClick={showOrHideNotificationPopup} size="large">
                {<ArrowDropUp fontSize="large" />}
              </IconButton>
            </span>
          </Box>
        </Grid>
        {notificationCount ? (
          <Grid size={{ xs: 12 }} component="div">
            <Box className={classes.notificationDetails}>
              {listNotification.map((noti: NotificationInterface) =>
                getNotificationDetail(noti)
              )}
            </Box>
          </Grid>
        ) : null}
      </Grid>
    </Dialog>
  ) : null;
};

const CustomNotification = () => (
  <ThemeProvider theme={theme}>
    <CustomNotificationContent />
  </ThemeProvider>
);

const connector = connect(null, null);
export default connector(CustomNotification);
